import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import AuthContext from '../store/AuthContext';
import classes from './Header.module.css';

const Header = () => {
  const authCtx = useContext(AuthContext);
  const logoutHandler = () => {
    authCtx.logout();
  };
  return (
    <header className={`flex-centered ${classes.header}`}>
      <nav>
        <NavLink
          to="/"
          className={(nav) => (nav.isActive ? classes.active : '')}
        >
          Home
        </NavLink>
        <NavLink
          to="/shop"
          className={(nav) => (nav.isActive ? classes.active : '')}
        >
          Shop
        </NavLink>
      </nav>
      <h1>BOUTIQUE</h1>
      <nav>
        <NavLink
          to="/cart"
          className={(nav) => (nav.isActive ? classes.active : '')}
        >
          <FontAwesomeIcon icon="fa-solid fa-cart-flatbed" />
          <span>Cart</span>
        </NavLink>
        {!authCtx.isLogedIn && (
          <NavLink
            to="/login"
            className={(nav) => (nav.isActive ? classes.active : '')}
          >
            <FontAwesomeIcon icon="fa-solid fa-user" />
            <span>Login</span>
          </NavLink>
        )}
        {authCtx.isLogedIn && (
          <>
            <NavLink
              to="/history"
              className={(nav) => (nav.isActive ? classes.active : '')}
            >
              History
            </NavLink>
            <div>
              <FontAwesomeIcon icon="fa-solid fa-user" />
              <span>{authCtx.user.fullName}</span>
              <FontAwesomeIcon icon="fa-solid fa-caret-down" />
            </div>
            <span onClick={logoutHandler} className={classes.logout}>
              (Logout)
            </span>
          </>
        )}
      </nav>
    </header>
  );
};

export default Header;
